"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

var _PrimaryAddons = _interopRequireDefault(require("./PrimaryAddons"));

var _ExtraAddons = _interopRequireDefault(require("./ExtraAddons"));

var _utils = require("../utils");

require("../styles/_request-addons.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var RequestAddons = /*#__PURE__*/function (_Component) {
  _inherits(RequestAddons, _Component);

  var _super = _createSuper(RequestAddons);

  function RequestAddons(props) {
    var _this;

    _classCallCheck(this, RequestAddons);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChangeAddon", function (field) {
      return function (newAddon) {
        var requestedAddons = _this.state.requestedAddons;
        var newAddons = (0, _utils.mergeAddon)(field, newAddon, requestedAddons);

        _this.setState({
          requestedAddons: newAddons
        });
      };
    });

    _defineProperty(_assertThisInitialized(_this), "addSrt", function () {
      var requestedAddons = _this.state.requestedAddons;
      var existingSRTs = [].concat(_toConsumableArray((0, _lodash.default)(requestedAddons, 'SRT_CAPTIONS', [])), [{
        value: null
      }]);

      var newAddons = _objectSpread({}, requestedAddons, {
        SRT_CAPTIONS: existingSRTs
      });

      _this.setState({
        requestedAddons: newAddons
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateSrt", function (index) {
      return function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            value = _ref.value,
            cost = _ref.cost;

        var requestedAddons = _this.state.requestedAddons;

        var existingSRTs = _toConsumableArray((0, _lodash.default)(requestedAddons, 'SRT_CAPTIONS', []));

        if (value) {
          existingSRTs.splice(index, 1, {
            value: value,
            cost: cost
          });

          var _newAddons = _objectSpread({}, requestedAddons, {
            SRT_CAPTIONS: existingSRTs
          });

          return void _this.setState({
            requestedAddons: _newAddons
          });
        }

        existingSRTs.splice(index, 1);

        var newAddons = _objectSpread({}, requestedAddons, {
          SRT_CAPTIONS: existingSRTs
        });

        _this.setState({
          requestedAddons: newAddons
        });
      };
    });

    var currentVersion = props.currentVersion;
    _this.state = {
      requestedAddons: currentVersion.requestedAddons
    };
    return _this;
  }

  _createClass(RequestAddons, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var requestedAddons = this.state.requestedAddons;
      var SRT_CAPTIONS = requestedAddons.SRT_CAPTIONS;
      this.setState({
        requestedAddons: _objectSpread({}, requestedAddons, {
          SRT_CAPTIONS: SRT_CAPTIONS || []
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$currentVe = _this$props.currentVersion,
          versionId = _this$props$currentVe.versionId,
          appliedAddons = _this$props$currentVe.appliedAddons,
          onCancel = _this$props.onCancel,
          onUpdateRequestedAddons = _this$props.onUpdateRequestedAddons,
          getAddonsCost = _this$props.getAddonsCost,
          isInternalMode = _this$props.isInternalMode,
          history = _this$props.history;
      var requestedAddons = this.state.requestedAddons;
      var estimatedCost = getAddonsCost(requestedAddons);

      var handleSave = function handleSave() {
        onUpdateRequestedAddons({
          versionId: versionId,
          requestedAddons: requestedAddons
        });
        onCancel();

        if (isInternalMode) {
          history.push('/traffic');
        }
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__header"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading5: true
      }, "Add Ons")), /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__wrapper"
      }, /*#__PURE__*/_react.default.createElement(_PrimaryAddons.default, {
        requestedAddons: requestedAddons,
        appliedAddons: appliedAddons,
        onChangeAddon: this.onChangeAddon
      }), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_ExtraAddons.default, {
        requestedAddons: requestedAddons,
        appliedAddons: appliedAddons,
        onChangeAddon: this.onChangeAddon
      }), /*#__PURE__*/_react.default.createElement(_commonReact.SrtCaptions, {
        showTitle: true,
        appliedAddons: appliedAddons,
        requestedAddons: requestedAddons,
        addSrt: this.addSrt,
        updateSrt: this.updateSrt,
        buttonText: "Add SRT Caption"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__total-price"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__total-price__text"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Approx. total of")), /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__total-price__sum"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
        heading4: true,
        noMargin: true
      }, "".concat(estimatedCost, ".00"))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "request-addons__controls"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        type: "TERTIARY",
        onClick: onCancel
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
        onClick: handleSave,
        className: "request-addons__controls__save-button"
      }, "Save Changes")));
    }
  }]);

  return RequestAddons;
}(_react.Component);

var _default = RequestAddons;
exports.default = _default;